import { useEffect } from 'react';

import { useUserStorageItem } from '@/modules/userStorage';
import { useGetCommonStore } from '@/store';
import {
  BONUS_SEEN_IDENTIFIER,
  type IBonusLastSeenInfo,
} from '../lib/bonusSeenInfo';
import { useActiveBonusesTabStore } from './activeBonusesTabStore';

export const useMarkBonusesSeenWhen = (isActive: boolean): void => {
  const useCommonStore = useGetCommonStore();
  const bonuses = useCommonStore.use.bonuses();
  const freespins = useCommonStore.use.freespins();

  const { setItem, isAvailable } = useUserStorageItem<IBonusLastSeenInfo>(
    BONUS_SEEN_IDENTIFIER
  );
  const setActiveBonusesTabOpen = useActiveBonusesTabStore(
    (state) => state.setOpen
  );

  useEffect(() => {
    setActiveBonusesTabOpen(isActive);

    return () => setActiveBonusesTabOpen(false);
  }, [isActive, setActiveBonusesTabOpen]);

  useEffect(() => {
    if (!(isActive && isAvailable)) return;
    const createdAtTimes = [...bonuses, ...freespins]
      .map(({ createdAt }) => new Date(createdAt).getTime())
      .filter(Number.isFinite);
    const lastSeenAt = new Date(
      Math.max(Date.now(), ...createdAtTimes)
    ).toISOString();

    setItem({ lastSeenAt });
  }, [isActive, isAvailable, setItem, bonuses, freespins]);
};
